import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import logo from '../image/logo.png';
import '../styles/header.css';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, toggleLanguage, themeMode, toggleThemeMode } = useLanguage();
  const isDark = themeMode === 'dark';

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const labels = {
    es: {
      inicio: 'Inicio',
      beneficios: 'Beneficios',
      galeria: 'Galeria',
      productos: 'Productos',
      recetas: 'Recetas',
      contacto: 'Contacto',
      brand: 'Sainza',
      aria: 'Cambiar idioma a ingles',
      navAria: 'Navegacion principal',
      mobileAria: 'Menu movil',
      openMenuAria: 'Abrir menu',
      themeAria: isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
    },
    en: {
      inicio: 'Home',
      beneficios: 'Benefits',
      galeria: 'Gallery',
      productos: 'Products',
      recetas: 'Recipes',
      contacto: 'Contact',
      brand: 'Sainza',
      aria: 'Switch language to Spanish',
      navAria: 'Main navigation',
      mobileAria: 'Mobile menu',
      openMenuAria: 'Open menu',
      themeAria: isDark ? 'Switch to light mode' : 'Switch to dark mode'
    }
  };

  const t = labels[language];

  const menuOptions = [
    { path: '/inicio', label: t.inicio },
    { path: '/beneficios', label: t.beneficios },
    { path: '/galeria', label: t.galeria },
    { path: '/productos', label: t.productos },
    { path: '/recetas', label: t.recetas },
    { path: '/contacto', label: t.contacto },
  ];

  const currentLabel =
    menuOptions.find((option) => option.path === location.pathname)?.label || t.brand;

  return (
    <header className="header">
      <div className="header-brand">
        <Link to="/inicio" className="header-logo-link" aria-label="Ir al inicio">
          <img src={logo} alt="Logo" className="header-logo" />
        </Link>
        <span className="current-menu">{currentLabel}</span>
      </div>
      <div className="header-center">
        <nav className="desktop-menu" aria-label={t.navAria}>
          {menuOptions.map((option) => (
            <NavLink
              key={option.path}
              to={option.path}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {option.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="header-right">
        <button
          type="button"
          className={`language-toggle ${language === 'en' ? 'is-english' : ''}`}
          onClick={toggleLanguage}
          aria-label={t.aria}
          title={language === 'es' ? 'ES' : 'EN'}
        >
          <span className="lang-label">ES</span>
          <span className="lang-thumb" />
          <span className="lang-label">EN</span>
        </button>
        <button
          type="button"
          className={`theme-toggle-mobile ${isDark ? 'is-dark' : ''}`}
          onClick={toggleThemeMode}
          aria-label={t.themeAria}
          title={t.themeAria}
        >
          {isDark ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
        </button>
        <button
          className={`hamburger-menu ${mobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label={t.openMenuAria}
          aria-expanded={mobileMenuOpen}
          type="button"
        >
          <div className="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </div>
      <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`} aria-label={t.mobileAria}>
        <ul>
          {menuOptions.map((option) => (
            <li key={option.path}>
              <NavLink
                to={option.path}
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={() => setMobileMenuOpen(false)}
              >
                {option.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
